module.exports = __webpack_public_path__ + "static/man-leaning-on-railing.9a071603.webp";